import PropTypes from "prop-types";
import {Button, Dialog, DialogActions, DialogContent, Typography} from "@material-ui/core";
import DialogTitle from "@material-ui/core/DialogTitle";
import DefaultType from "../../../../../../../../../Utils/Form/FormDynamic/Fields/DefaultType/DefaultType";
import {useContext, useEffect, useState} from "react";
import {toPng} from "html-to-image";
import {ScreenDesignerContextNew} from "../../../../../../../../../ContextComponents/ScreenDesignerContextNew";
import request from "../../../../../../../../../Services/API/Requests";

const SaveTemplateDialog = (props) => {
    const {selectedComponent, selectedComponentRef} = useContext(ScreenDesignerContextNew);
    const {open, onClose} = props;
    const [previewImg, setPreviewImg] = useState(null);
    const [name, setName] = useState("");

    useEffect(() => {
        if (open) {
            //get component image
            if (selectedComponentRef && selectedComponentRef.current) {
                const children = selectedComponentRef.current.children[0];
                toPng(children).then(res => {
                    setPreviewImg(res);
                }).catch(err => {
                    console.log(selectedComponentRef.current)
                    console.log('generate image error', err)
                })
            }

        }
    }, [open]);

    function onChange(v) {
        setName(v)
    }

    async function onApply() {
        try {
            if(selectedComponent && selectedComponent.component.styles) {
                await request({
                    url: "/componentStyleTemplates/create",
                    data: {
                        type: selectedComponent.component.type,
                        name,
                        thumbnail: previewImg,
                        styles: selectedComponent.component.styles,
                    }
                })
                onClose();
            }
        } catch (e) {
            console.log(e)
        }
    }


    return (
        <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth={"md"}>
            <DialogTitle
                style={{
                    padding: '8px 14px',
                    fontSize: '0.5rem'
                }}
            >
                <Typography variant={"h6"}>
                    Save style template
                </Typography>
            </DialogTitle>
            <DialogContent>
                <div style={{display: 'flex', justifyContent: 'center', padding: 10, border: '3px dashed #e0e0e0'}}>
                    <img src={previewImg} alt={'preview img'} style={{maxWidth: '100%'}}/>
                </div>
                <div
                    style={{
                        padding: 10,
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center'
                    }}
                >
                    <DefaultType
                        field={{
                            label: "Template name",
                            path: 'name',
                            autofocus: true
                        }}
                        fieldStyles={{
                            presentation: "standard",
                            margin: "10px 0"
                        }}
                        globalValues={{name}}
                        setValue={onChange}
                    />
                </div>
            </DialogContent>
            <DialogActions>
                <Button variant={"contained"} color={'primary'} size={'small'} onClick={onApply}>
                    Save
                </Button>
                <Button variant={"contained"} color={'default'} size={'small'}>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    )
}
export default SaveTemplateDialog;

SaveTemplateDialog.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func
}